import React, { useContext } from "react";
import { Context } from "../Context/Context";
import "./Order.css";
function Order(props) {
  const context = useContext(Context);
  function hideOrderDiv() {
    props.setOrderDiv(false);
  }
  return (
    <div className="order-outer-div">
      <div className="div-around-oops-p-button">
        {context.isLogged? (
          <p className="oops-p">
            Oops sorry restaurant is closed for a while 🙁...
          </p>
        ) : (
          <p className="oops-p">You should register first 😐.</p>
        )}

        <button className="close-order-button" onClick={hideOrderDiv}>
          Close
        </button>
      </div>
    </div>
  );
}

export default Order;
